// extracted by mini-css-extract-plugin
export default {"link":"Formaciones_link__0F+d5","fab":"Formaciones_fab__jF2HF"};